import {
  defaultRenderMessages,
  type MessageRenderer,
  type GroupStyle,
} from 'stream-chat-react';

export const renderMessagesNewestFirst: MessageRenderer = options => {
  const { messages, ...rest } = options;

  const reversedMessages = [...messages].reverse();

  const messageGroupStyles = reversedMessages.reduce<
    Record<string, GroupStyle>
  >((acc, message, i) => {
    if (i === 0) {
      acc[message.id] = 'top';
    } else if (i === reversedMessages.length - 1) {
      acc[message.id] = 'bottom';
    } else {
      acc[message.id] = 'middle';
    }

    return acc;
  }, {});

  return defaultRenderMessages({
    ...rest,
    messages: reversedMessages,
    messageGroupStyles,
  });
};
